import { gql } from 'apollo-boost';

export const CREATE_CART_DOCTOR = gql`
  mutation doCreateCartDoctor($data: CartDoctorInput!) {
    createCartDoctor(data: $data) {
      id
      doctorId
      firstName
      lastName
      company
      address1
      address2
      city
      zip
      state
      country
      phone
    }
  }
`;
